import apiClient from './client';

export async function getAccounts() {
  const res = await apiClient.get('/api/v1/accounts');
  return res.data;
}

export async function getSyncStatus() {
  const res = await apiClient.get('/api/v1/accounts/sync-status');
  return res.data;
}

export async function connectAccount() {
  const res = await apiClient.post('/api/v1/accounts/connect');
  return res.data; // { redirectUrl }
}

export async function setupAccount(brokerageAuthorizationId) {
  const res = await apiClient.post('/api/v1/accounts', { brokerageAuthorizationId });
  return res.data;
}

export async function toggleAccountActive(id) {
  return apiClient.patch(`/api/v1/accounts/${id}/active`);
}

export async function reconnectAccount(id, brokerageAuthorizationId) {
  const res = await apiClient.post(`/api/v1/accounts/${id}/reconnect`, { brokerageAuthorizationId });
  return res.data; // { redirectUrl }
}

export async function getAllAccounts() {
  const res = await apiClient.get('/api/v1/accounts/all');
  return res.data;
}

export async function cleanupAccounts(reason) {
  const body = reason ? { reason } : {};
  return apiClient.post('/api/v1/accounts/cleanup', body);
}